import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { ParentJourneyManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/parent-journey")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <ParentJourneyManagement />
    </RouteGuard>
  ),
});
